module.exports = __webpack_public_path__ + "24710134c85c64f68d0be9832d4570d5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/skillset-banners/banner-key-ideas.png
// module id = 2969
// module chunks = 0